import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { TariffTypeEntity } from "domain/entity/TariffType/TariffTypeEntity";
import { axiosDeleteData, axiosGetData, axiosPostData, axiosPutData } from "../axios/AxiosBasicImpl";
import tariffAxiosInstance from "../axios/tariffAxiosInstance";
import { TariffTypeRepository } from "./TariffTypeRepo";

export const TariffTypeRepoImpl = (): TariffTypeRepository => {
    const url = '/v1/tariffType';

    const getEntities = async() : Promise<TariffTypeEntity[]> => {
        return await axiosGetData(tariffAxiosInstance, url, []).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });
        
    }

    const getEntityByKey = async(key: string): Promise<TariffTypeEntity> => {
        return await axiosGetData(tariffAxiosInstance, `${url}/${key}`, []).then(res => {
            return res.data;
        }).catch(err => {
            return null;
        });
    }

    const createEntity = async(newData: TariffTypeEntity) : Promise<ResponseEntity> => {
        return await axiosPostData(tariffAxiosInstance, `${url}`, newData);
    }

    const updateEntity = async(updatedData: TariffTypeEntity): Promise<ResponseEntity> => {
        return await axiosPutData(tariffAxiosInstance, `${url}`, updatedData);
    }

    const deleteEntity= async(key: string): Promise<ResponseEntity> => {
        return await axiosDeleteData(tariffAxiosInstance, `${url}`, key);
    }

    return {
        getEntities: getEntities,
        getEntityByKey: getEntityByKey,
        createEntity: createEntity,
        updateEntity: updateEntity,
        deleteEntity: deleteEntity,
    }
}